export const BankIcon = ({ color = '#0064FF', ...props }) => (
  <svg
    width={'30'}
    height={'30'}
    viewBox={'0 0 30 30'}
    fill={'none'}
    xmlns={'http://www.w3.org/2000/svg'}
    {...props}
  >
    <title>Bank Icon</title>
    <path
      d={'M7.2447 10.7366H6.84633C5.92587 10.7366 5.17969 11.4828 5.17969 12.4032V23.4015C5.17969 24.322 5.92587 25.0682 6.84633 25.0682H7.2447C8.16516 25.0682 8.91135 24.322 8.91135 23.4015V12.4032C8.91135 11.4828 8.16516 10.7366 7.2447 10.7366Z'}
      fill={color}
    />
    <path
      d={'M15.565 10.7366H15.1666C14.2462 10.7366 13.5 11.4828 13.5 12.4032V23.4015C13.5 24.322 14.2462 25.0682 15.1666 25.0682H15.565C16.4855 25.0682 17.2317 24.322 17.2317 23.4015V12.4032C17.2317 11.4828 16.4855 10.7366 15.565 10.7366Z'}
      fill={color}
    />
    <path
      d={'M26.1408 22.1907H4.59633C3.67587 22.1907 2.92969 22.9369 2.92969 23.8573V24.287C2.92969 25.2075 3.67587 25.9537 4.59633 25.9537H26.1408C27.0612 25.9537 27.8074 25.2075 27.8074 24.287V23.8573C27.8074 22.9369 27.0612 22.1907 26.1408 22.1907Z'}
      fill={color}
    />
    <path
      d={'M23.651 10.7366H23.2526C22.3321 10.7366 21.5859 11.4828 21.5859 12.4032V23.4015C21.5859 24.322 22.3321 25.0682 23.2526 25.0682H23.651C24.5714 25.0682 25.3176 24.322 25.3176 23.4015V12.4032C25.3176 11.4828 24.5714 10.7366 23.651 10.7366Z'}
      fill={color}
    />
    <path
      d={'M16.1189 3.694C15.647 3.45605 15.0901 3.45605 14.6182 3.694L3.78333 9.15696C3.25987 9.42089 2.92969 9.95714 2.92969 10.5434V10.5434C2.92969 11.4009 3.62484 12.096 4.48236 12.096H26.2547C27.1123 12.096 27.8074 11.4009 27.8074 10.5434V10.5434C27.8074 9.95714 27.4772 9.42089 26.9538 9.15696L16.1189 3.694Z'}
      fill={color}
    />
  </svg>
);
